<ion-item detail="false" lines="none" button (click)="emitEvent()">
  <ion-icon *ngIf="showIcon"  #icon slot="end" src="assets/svg/edit-icon.svg" (click)="setIconRef($event)"></ion-icon>

  <ion-label class="ion-hide-sm-down" width-3>
    <h3 class="text-primary-dark ion-text-wrap"> {{ title }} </h3>
  </ion-label>

  <ion-label class="ion-hide-sm-up">
    <h2 class="text-primary-dark ion-text-wrap"> {{ title }} </h2>
  </ion-label>
</ion-item>
<div class="divider"></div>
